import 'promise-polyfill/src/polyfill';
import 'lazysizes';
import objectFitImages from 'object-fit-images';
objectFitImages();

//import {gsap, Power1, Power3} from 'gsap/all';
//import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
//gsap.registerPlugin(ScrollToPlugin);

//////////////////////////////
// グローバル変数
//////////////////////////////
window.gFNS = [];
window.gFNS.rootHTML = document.documentElement;
window.gFNS.lang = window.gFNS.rootHTML.lang;
window.gFNS.mods = [];
window.gFNS.isDevice = '';
window.gFNS.isAndroid = false;
window.gFNS.isEnableTouch = false;
window.gFNS.siteUrl = location.protocol + '//' + location.hostname;
if (location.port != 80) {
  window.gFNS.siteUrl += ':' + location.port;
}

const ua = navigator.userAgent.toLowerCase();
if (/iphone|ipad|macintosh|ipod/.test(ua) && 'ontouchend' in document) {
  gFNS.rootHTML.classList.add('fn22-mobile');
  gFNS.isDevice = 'mobile';
  gFNS.isAndroid = false;
} else if (/android/.test(ua) && 'ontouchend' in document) {
  gFNS.rootHTML.classList.add('fn22-mobile');
  gFNS.isDevice = 'mobile';
  gFNS.isAndroid = true;
} else {
  gFNS.rootHTML.classList.add('fn22-pc');
  gFNS.isDevice = 'pc';
  gFNS.isAndroid = false;
}

if(window.ontouchstart !== undefined && 0 < navigator.maxTouchPoints) {
  gFNS.isEnableTouch = true;
}

//history.scrollRestoration = 'manual';
